<ion-header class="remove-safe-area ion-no-border">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="closeModal()" 
              ><ion-icon color="dark" name="close"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col style="text-align: center;">
        <h2 class="subheader-regular">Submission</h2>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <div *ngFor="let formItem of results">

          <!-- header -->
        <div lines="none" *ngIf="formItem.type=='header'">
          <h1 *ngIf="formItem.subtype=='h1'">{{formItem.label}}</h1>
          <h2 *ngIf="formItem.subtype=='h2'">{{formItem.label}}</h2>
          <h3 *ngIf="formItem.subtype=='h3'">{{formItem.label}}</h3>
          <h4 *ngIf="formItem.subtype=='h4'">{{formItem.label}}</h4>
          <h5 *ngIf="formItem.subtype=='h5'">{{formItem.label}}</h5>
          <h6 *ngIf="formItem.subtype=='h6'">{{formItem.label}}</h6>
        </div>
    
        <!-- number -->
        <ion-card style="margin: 0.3em;" *ngIf="formItem.type!='header' && formItem.type!='paragraph'"  class="card-shadow-3">
          <ion-item  lines="none">
            <ion-label>{{formItem.label}}<span
              *ngIf="formItem.required"
              style="color: red"
              > *</span
            >:</ion-label>
            <ion-label style="text-align: right;">{{formItem.value}}</ion-label>
            <ion-note slot="helper">{{formItem.description}}</ion-note>
            
          </ion-item>
        <!-- paragraph -->
        <div *ngIf="formItem.type=='paragraph'">
          <p class="ion-text-wrap">{{formItem.label}}</p>
        </div>
      </ion-card>
        
    
        <!-- file upload -->
        <!-- <div *ngIf="formItem.type=='file'">
          <ion-item >
            <ion-label>{{formItem.label}}<span
              *ngIf="formItem.required"
              style="color: red"
              > *</span
            >:</ion-label>
          
              
              
          </ion-item> -->
          <!-- <ion-item *ngFor="let file of files; let i = index">
            <ion-thumbnail slot="start">
              <ion-img *ngIf="file.type!='.pdf'" [src]="file.data"></ion-img>
              <ion-img *ngIf="file.type=='.pdf'" src="assets/files/pdf.png"></ion-img>
            </ion-thumbnail>
            <ion-label class="ion-text-wrap"> {{ file.name }} </ion-label>
            <ion-button (click)="removeFile(i)" slot="end"  fill="clear">
              <ion-icon color="danger" slot="icon-only" name="trash"></ion-icon>
            </ion-button>
          </ion-item> -->
        <!-- </div> -->
    
        
      
        
      </div>
      </ion-col>
    </ion-row>
  </ion-grid>
    
   
  

  
  <!-- <ion-button (click)="submitForm()" [disabled]="!formGroup.valid " expand="block" color="dark">{{ ('keys.data.common.submit' | translate : {Default:'Form Description'}) ||
    'Form Description' }}</ion-button> -->


</ion-content>
